import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { gerarUrlBranding } from '@/utils/avatar';

export interface BrandingUnidade {
  id_unidade: string;
  nome: string;
  logo_oficial: string | null;
  cor_primaria_hex: string | null;
  cor_secundaria_hex: string | null;
}

/**
 * Busca branding da unidade (vw_branding_ativo) para uso em componentes públicos
 * (ex.: dialog de candidatura).
 */
export function useBrandingUnidade(idUnidade: string | undefined | null) {
  return useQuery({
    queryKey: ['branding-unidade', idUnidade],
    enabled: !!idUnidade,
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<BrandingUnidade | null> => {
      const { data, error } = await supabase
        .from('vw_branding_ativo' as any)
        .select('id_unidade, nome, logo_oficial, cor_primaria_hex, cor_secundaria_hex')
        .eq('id_unidade', idUnidade!)
        .maybeSingle();
      if (error) throw error;
      if (!data) return null;
      
      const logoUrl = await gerarUrlBranding((data as any).logo_oficial);
      return {
        ...(data as any),
        logo_oficial: logoUrl
      } as BrandingUnidade;
    },
  });
}
